'use client'

import { Builder } from '@builder.io/react'

import { UserRegistration } from '@src/components/UserRegistration/UserRegistration'

import { defaultProps } from './UserRegistration.defaults'

Builder.registerComponent(UserRegistration, {
  name: 'UserRegistrationForm',
  noWrap: true,
  inputs: [
    {
      name: 'theme',
      type: 'string',
      enum: [
        { label: 'Light', value: 'light' },
        { label: 'Dark', value: 'dark' },
      ],
      defaultValue: defaultProps.theme,
    },
    {
      name: 'termsAndConditionsLink',
      type: 'string',
      defaultValue: defaultProps.termsAndConditionsLink,
    },
    {
      name: 'buttonTestId',
      type: 'string',
      defaultValue: defaultProps.buttonTestId,
    },
    {
      name: 'submitButtonText',
      type: 'string',
      defaultValue: defaultProps.submitButtonText,
    },
    {
      name: 'privacyPolicyLink',
      type: 'string',
      defaultValue: defaultProps.privacyPolicyLink,
    },
    {
      name: 'redirectUrl',
      friendlyName: 'Redirect URL',
      type: 'string',
      helperText:
        'URL to redirect to after successful registration (optional). If not set, the success view will be displayed.',
      localized: true,
    },
  ],
  image: 'https://unpkg.com/@tabler/icons@2.44.0/icons/forms.svg',
})
